import { withStyles } from '@material-ui/styles';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';

export const InvisibleAccordion = withStyles({
    root: {
        border: '0 none transparent',
        boxShadow: 'none',
        padding: 0,
        '&$expanded': {
            margin: 'auto'
        },
        '&:before': {
            height: 0
        }
    },
    expanded: {}
})(Accordion);

export const InvisibleAccordionSummary = withStyles({
    root: {
        padding: 0
    },
    content: {
        '&$expanded': {
            margin: '12px 0'
        }
    },
    expanded: {}
})(AccordionSummary);

export const InvisibleAccordionDetails = withStyles({
    root: {
        padding: 0,
        width: '100%'
    },
    content: {
        margin: 0
    }
})(AccordionDetails);
